import { BellaTranslator } from '@westwing/appshell_types/bellaTranslator';
import {
    FormValue,
    FormState,
    RuleValidateFn,
    ValidationSchema,
} from '@westwing/ui-kit/Tools/hooks/useForm/useForm.types';
import isPassword, { MIN_PASSWORD_LENGTH } from '@westwing/ui-kit/Tools/Validation/isPassword';
import isEmpty from '@westwing/ui-kit/Tools/Validation/isEmpty';

export const REQUIRED_FIELD = 'Required field';
export const PASSWORD_TOO_SHORT_MSG = `Min %d characters`;
export const PASSWORD_NOT_MATCHING = 'Passwords did not match';
const isRequired = (value: string) => !isEmpty(value);
const matchField =
    (field: string): RuleValidateFn =>
    (value: FormValue, state: FormState) =>
        state[field] === value;

export default (translator: BellaTranslator): ValidationSchema => {
    const applyTrans = (conf: [string, string[]]) => translator(...conf);
    return {
        password: [
            {
                validate: isRequired,
                message: applyTrans([REQUIRED_FIELD, []]),
            },
            {
                validate: isPassword,
                message: applyTrans([PASSWORD_TOO_SHORT_MSG, [MIN_PASSWORD_LENGTH.toString()]]),
            },
        ],
        confirmPassword: [
            {
                validate: isRequired,
                message: applyTrans([REQUIRED_FIELD, []]),
            },
            {
                validate: matchField('password'),
                message: applyTrans([PASSWORD_NOT_MATCHING, []]),
            },
        ],
    };
};
